// extracted by mini-css-extract-plugin
module.exports = {"user-page-header":"header_user-page-header__3jy5P","admin-page-header":"header_admin-page-header__2DXz2","agrisud-header":"header_agrisud-header__1V966"};